import Image from "next/image";
const vision = "/assets/about/vision.webp";

export default function VisionAndMisson() {
  return (
    <div className="grid sm:grid-cols-3 w-full max-w-[2000px] mt-5 xl:mt-[100px] mx-auto">
      <div className="relative md:max-w-[460px] pl-3 mt-[63px]">
        {/* left side line */}
        <div className="relative flex items-stretch">
          <div className="mt-4 w-px bg-foreground" />
          <div className="ml-4">
            <h1 className="font-alexandria font-semibold text-[28px] md:text-[32px] xl:text-[50px] uppercase">
              Vision
            </h1>
            <p className="font-manrope font-light text-[14px] md:text-[16px] lg:text-[20px] xl:text-[26px] text-paragraph">
              To be the global catalyst for innovation, where engineering
              precision meets digital intelligence to build systems that shape a
              smarter, sustainable future.
            </p>
          </div>
        </div>
      </div>

      <div className="relative w-[212px] h-[321px] xl:w-[424px] xl:h-[642px] mx-auto justify-self-center">
        <img
          src={vision}
          alt="Vision and mission illustration"
          className="object-cover absolute inset-0 w-full h-full"
          style={{ objectFit: "cover" }}
          loading="eager"
        />
      </div>

      <div className="relative md:max-w-[460px] pr-3 self-end justify-self-end text-right mr-0">
        <div className="flex items-stretch">
          <div className="mr-4">
            <h1 className="font-alexandria font-semibold text-[28px] md:text-[32px] xl:text-[50px] uppercase">
              Mission
            </h1>
            <p className="font-manrope font-light text-[14px] md:text-[16px] lg:text-[20px] xl:text-[26px] text-paragraph">
              We strive to deliver high-quality MVPs and intelligent digital
              platforms through precise engineering and innovative practices,
              enabling sustainable growth and future-ready transformation.
            </p>
          </div>
          {/* right side line */}
          <div className="mt-4 w-px bg-foreground" />
        </div>
      </div>
    </div>
  );
}
